// private apis
export const FDD_API_URL = '/v1/fdds';
export const ZOR_API_URL = '/v1/zors';
export const STAGE_API_URL = '/v1/stages';
export const WORKBOOK_API_URL = '/v1/workbooks';
export const ZOR_MEMBER_API_URL = '/v1/zor-members';
export const FRANCHISEE_API_URL = '/v1/franchisees';
export const ZOR_DOCUMENT_API_URL = '/v1/zor-documents';
export const ZEE_DOCUMENT_API_URL = '/v1/zee-documents';
export const FEATURELOCKS_API_URL = '/v1/feature-locks';
export const ZOR_FINANCIAL_API_URL = '/v1/zor-financials';
export const STAGE_PROMPTS_API_URL = '/v1/aimei/stage-prompts';
export const AIMEI_PROMPTS_API_URL = '/v1/aimei/general-prompts';
export const DISCOVERY_STAGE_API_URL = '/v1/discovery-stages';
export const ZOR_GENERAL_SETTING_API_URL = '/v1/zor-general-settings';
export const LINKS_API_URL = '/v1/links';
export const STORAGE_UPLOAD_AVATAR_API_URL = '/v1/storage/upload-avatar';

// zee apis
export const ZEE_API_URL = '/v1/zees';
export const ZEE_FINANCIAL_API_URL = '/v1/zee-financials';
export const ZEE_BACKGROUND_API_URL = '/v1/zee-backgrounds';
export const ZEE_FEATURE_LOCKS_API_URL = '/v1/zee-feature-locks';
export const USERS_API_URL = '/v1/users';
export const MY_DISCOVERY_API_URL = `${USERS_API_URL}/me/discovery`;

// user apis
export const USER_ONLINE_STATUS_API_URL = '/v1/users/online-status';

// clerk apis
export const JOIN_ORG_API_URL = '/api/join-org';
export const ORG_INVITE_API_URL = '/api/send-org-invitation';
export const CHANGE_PASSWORD_API_URL = '/api/change-password';

// territories apis
export const HEATMAP_API_URL = '/api/heatmap';
export const ZIP_CODES_API_URL = '/api/zip-codes';
export const TERRITORIES_API_URL = '/api/territories';
export const ASSIGNED_TERRITORIES_API_URL = '/api/assigned-territories';
export const STATE_PREFERENCE_SUMMARY = '/api/state-preference-summary';
export const STATE_COMPLIANCE_API_URL = '/api/states-compliance';
export const TERRITORIES_LIKES_API_URL = '/api/territories-likes';
export const TERRITORIES_REQUESTS_API_URL = '/api/territories-requests';
export const CENSUS_DATA_FIELDS_API_URL = '/api/acs-variables';
export const TERRITORY_SETTINGS_API_URL = '/api/territory-settings';
export const AVAILABLE_ZIP_CODES_COUNT_API_URL =
  '/api/available-zip-codes-count';

// cache apis
export const CLEAR_CACHE_API_URL = '/api/cache/clear';

const PUBLIC_API_URLs: Array<string> = [
  // clerk apis
  ORG_INVITE_API_URL,
  CHANGE_PASSWORD_API_URL,
  // territories apis
  CENSUS_DATA_FIELDS_API_URL,
];

export { PUBLIC_API_URLs };
export const STORAGE_UPLOAD_API_URL = '/v1/storage/upload';
export const STORAGE_SIGNED_URL_API_URL = '/v1/storage/signed-url';
